import { DatepickerModule, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { ChartsModule } from 'ng2-charts';
import { NgxSelectModule } from 'ngx-select-ex';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { SharedModule } from '../../shared/shared.module';
import { CentroDeCustoComponent } from './centroDeCusto/centroDeCusto.component';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AgmCoreModule } from '@agm/core';
import { TextMaskModule } from 'angular2-text-mask';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InicioComponent } from './inicio/inicio.component';
import { EmpresaComponent } from './empresa/empresa.component';
import { AuxiliarEmpresaComponent } from './empresa/auxiliar/auxiliar-empresa.component';
import { AlterarsenhaComponent } from './empresa/alterarsenha/alterarsenha.component';
import { RegistrarContatoComponent } from './empresa/registrar-contato/registrar-contato.component';
import { ModalRegistrarContatoComponent } from './empresa/modal-registrar-contato/modal-registrar-contato.component';
import { ModalInformacaoEmpresaComponent } from './empresa/modal-informacao-empresa/modal-informacao-empresa.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { AlterarsenhaComponent as SenhaUsuario } from './usuarios/auxiliar/alterarsenha/alterarsenha.component';
import { UsuariosAuxiliarComponent } from './usuarios/auxiliar/auxiliar-usuarios.component';
import { NotificacaoComponent } from './notificacao/notificacao.component';
import { ParametroPagamentoPontoComponent } from './parametro-pagamento-ponto/parametro-pagamento-ponto.component';
import { TransacoesPontosComponent } from './transacoes-pontos/transacoes-pontos.component';
import { ModalParametroPontoComponent } from './parametro-pagamento-ponto/modal-parametro-ponto/modal-parametro-ponto.component';
import { ValidarEmpresaComponent } from './empresa/validar-empresa/validar-empresa.component';







const routes: Routes = [
  { path: 'inicio', component: InicioComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'centrodecusto', component: CentroDeCustoComponent },
  { path: 'empresa', component: EmpresaComponent },
  { path: 'empresa/editar/:id', component: AuxiliarEmpresaComponent },
  { path: 'empresa/validar', component: ValidarEmpresaComponent },
  { path: 'empresa/alterarsenha', component: AlterarsenhaComponent },
  { path: 'empresa/registrarcontato', component: RegistrarContatoComponent },
  { path: 'usuario', component: UsuariosComponent },
  { path: 'usuario/alterarsenha', component: SenhaUsuario },
  { path: 'usuario/editar/:id', component: UsuariosAuxiliarComponent },
  { path: 'notificacoes', component: NotificacaoComponent },
  { path: 'parametropagamentopontos', component: ParametroPagamentoPontoComponent },
  { path: 'transacoespontos', component: TransacoesPontosComponent }



];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    NgxSelectModule,
    Ng2TableModule,
    NgxDatatableModule,
    TextMaskModule,
    ChartsModule,
    NgxMaskModule,
    CurrencyMaskModule,
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: '2VSHIjwp3s9qJMh-346q41IzT1k=',
    }),
  ],
  declarations: [
    CentroDeCustoComponent,
    DashboardComponent,
    InicioComponent,
    EmpresaComponent,
    AuxiliarEmpresaComponent,
    AlterarsenhaComponent,
    RegistrarContatoComponent,
    ModalRegistrarContatoComponent,
    ModalInformacaoEmpresaComponent,
    UsuariosComponent,
    SenhaUsuario,
    UsuariosAuxiliarComponent,
    NotificacaoComponent,
    ParametroPagamentoPontoComponent,
    TransacoesPontosComponent,
    ModalParametroPontoComponent,
    ValidarEmpresaComponent
  ],
  exports: [RouterModule, NgxSelectModule, BsDatepickerModule, DatepickerModule],
  entryComponents: [ModalRegistrarContatoComponent, ModalInformacaoEmpresaComponent, ModalParametroPontoComponent]
})
export class V1Module { }
